import { getById } from '@/store/module/club/getter/getById.js';
import { getClubByName } from '@/store/module/club/getter/getClubByName.js';
import { getClubs } from '@/store/module/club/getter/getClubs.js';
import { hasAdminPrivileges } from '@/store/module/club/getter/hasAdminPrivileges.js';
import { hasRole } from '@/store/module/club/getter/hasRole.js';

export const getters = {
	getById,
	getClubByName,
	getClubs,
	hasAdminPrivileges,
	hasRole
};
